<template>
  <PageContent>
    <StepsV2 :step="2" />
    <PanelV2
      type="w6"
      title="Enter your business details"
      @nextClick="commitData()"
    >
      <template v-slot:title-solt>
        <BdoProgress :step="1" :total="3" />
      </template>
      <template v-slot:content-solt>
        <AppForm
          ref="appForm"
          v-model="formData"
         />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  import AppForm from "../forms/SolePropF.val";
  import API from "@/api";

  export default {
    name: 'SolePropF',
    pRouter: 'SolePropE',
    components: {
      AppForm,
    },
    data() {
      return {
        formData: {},
      }
    },
    methods: {
      commitData() {

        this.$refs.appForm.$refs.appForm.validate((valid) => {

          const data = this.formatCommitData({...this.formData})

          if (valid) {

            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          }
        });
      }
    }
  }
</script>
